// src/components/admin/AdminTopBar.jsx
import { useState } from 'react';
import { Search, User, LogOut } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const AdminTopBar = ({ user }) => {
  const { logout } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="h-16 bg-bg-surface border-b border-gray-200 flex items-center justify-between px-6">
      {/* Title */}
      <div>
        <h1 className="text-xl font-semibold text-text-primary">Content Management</h1>
      </div>

      {/* Search - Placeholder for V1 */}
      <div className="flex-1 max-w-md mx-8">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-text-secondary w-4 h-4 pointer-events-none" />
          <input
            type="text"
            placeholder="Search books..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-200 focus:border-primary-300"
          />
        </div>
      </div>

      {/* User Menu */}
      <div className="flex items-center space-x-4">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center">
            <User className="w-4 h-4 text-primary-600" />
          </div>
          <div className="text-sm">
            <div className="text-text-primary font-medium">
              {user?.display_name || user?.name || 'Admin User'}
            </div>
            <div className="text-text-secondary text-xs">
              {user?.email || 'admin@bukito.com'}
            </div>
          </div>
        </div>

        <button
          className="p-2 text-text-secondary hover:text-text-primary hover:bg-gray-50 rounded-lg transition-colors"
          title="Logout"
          onClick={logout}
        >
          <LogOut className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default AdminTopBar;
